<template>
  <div>
    <button
      class="btn btn-base"
      >
      Actualizar Respuestas
    </button>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
